import React, { useMemo } from "react";

import { EmptyState } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";

import {
  SUBMISSION_TYPE_DRAFT,
  SUBMISSION_TYPE_FINAL,
  SUBMISSION_TYPE_IB_DEFINED,
} from "Projects/Constants/stringConstants";
import {
  ProjectOverviewIllustration,
  NothingAssignedIllustration,
} from "@toddle-edu/ds-theme";

const EmptyStateComponent = props => {
  const { submissionType, isStudentSubmissionEnabled, studentName } = props;
  const { t } = useI18n(["common", "project"]);

  const { illustration, title } = useMemo(() => {
    switch (submissionType) {
      case SUBMISSION_TYPE_DRAFT:
      case SUBMISSION_TYPE_FINAL:
      case SUBMISSION_TYPE_IB_DEFINED: {
        return {
          illustration: ProjectOverviewIllustration,
          title: t("project:no_work_added_with_student_name", {
            studentName: studentName,
          }),
        };
      }
      default: {
        if (isStudentSubmissionEnabled) {
          return {
            illustration: ProjectOverviewIllustration,
            title: t("project:no_work_added_with_student_name", {
              studentName: studentName,
            }),
          };
        } else {
          return {
            illustration: NothingAssignedIllustration,
            title: t("project:no_submission_deadline_empty_state_title"),
          };
        }
      }
    }
  }, [submissionType, isStudentSubmissionEnabled]);

  return <EmptyState illustration={illustration} title={title} />;
};

export default EmptyStateComponent;
